// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".show-description-link[data-v-0d793b3c] {\n  font-size: 13px;\n  font-weight: 500;\n  color: #0066ff;\n  cursor: pointer;\n}\n.show-description-link--mini .show-description-link-text[data-v-0d793b3c] {\n    display: none;\n}\n@media (max-width: 767px) {\n.show-description-link--mini .show-description-link-text[data-v-0d793b3c] {\n      display: inline;\n      margin-left: 10px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
